import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const ImageLightbox = ({ product, open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid={`lightbox-${product.id}`}
      className="w-[calc(100vw-1.5rem)] max-w-4xl grid-cols-1 border-white/10 bg-ink p-3 text-white sm:p-4 [&>button]:text-white"
    >
      <DialogTitle className="pr-8 font-display text-lg font-bold uppercase text-white">{product.name}</DialogTitle>
      <div
        className="flex items-center justify-center rounded-lg bg-gradient-to-b from-[#e2e2e2] to-[#c4c4c4]"
        style={product.imageBg ? { background: product.imageBg } : undefined}
      >
        <img
          src={product.image}
          alt={product.alt}
          data-testid={`lightbox-image-${product.id}`}
          className="max-h-[80vh] w-auto max-w-full object-contain"
        />
      </div>
    </DialogContent>
  </Dialog>
);

export default ImageLightbox;
